import ENDPOINTS from '@utils/apiEndpoints';
import { axiosInstance } from '@utils/axiosInstance';
import { onApiError, onApiSuccess } from '@utils/utilities';

export const validationCodeCheckService = (data: any) => {
  return axiosInstance
    .post(ENDPOINTS.ADMIN.PASSWORD.VALIDATION_CODE_CHECK, data)
    .then((response) => {
      return onApiSuccess(response);
    })
    .catch((error) => {
      return onApiError(error);
    });
};
